<template>
  <l-map v-if="center" ref="customMap" :zoom="zoom" :center="center">
    <l-control-layers position="topright"></l-control-layers>
    <l-tile-layer v-for="tileProvider in TILE_PROVIDERS" :key="tileProvider.name" :name="tileProvider.name"
      :visible="tileProvider.visible" :url="tileProvider.url" layer-type="base"
      :attribution="tileProvider.attribution" />
    <l-control position="bottomleft">
      <strong style="color:red"></strong>
    </l-control>
    <l-marker v-for="dot in dots" :lat-lng="dot.coord" :key="dot.id + dot.name" @click="onClickMarker(dot)">
      <l-tooltip>{{ dot.name }}</l-tooltip>
      <l-icon v-if="dot.icon" :icon-url="dot.icon" :iconAnchor="[5, 22]" />
    </l-marker>
  </l-map>
</template>

<script setup>
import { defineEmits, defineProps } from 'vue';
import "leaflet/dist/leaflet.css";
import {
  LMap,
  LTileLayer,
  LControlLayers,
  LControl,
  LMarker,
  LTooltip,
  LIcon,
} from "@vue-leaflet/vue-leaflet";
import { TILE_PROVIDERS } from "./mapConstants";

const props = defineProps({
  zoom: {
    type: Number,
    default: 11,
  },
  dots: {
    type: Array,
    default: () => [],
  },
  center: {
    default: null,
  },
});

const emit = defineEmits(["on-click-marker"]);

function onClickMarker(dot) {
  emit("on-click-marker", dot);
}
</script>